export const SESSION_LOGIN = "SESSION_LOGIN";
export const SESSION_GROUP_LOGIN = "SESSION_GROUP_LOGIN";
export const MEMBER_LOGIN = "MEMBER_LOGIN";
export const MEMBER_GROUP_LOGIN = "MEMBER_GROUP_LOGIN";
export const UNIT_USER_GROUP_LOGIN = "UNIT_USER_GROUP_LOGIN";
